<script module>
    import update from "@axel669/immutable-update"

    export const newBag = (override) => update(
        {
            pos: 1,
            time: Date.now(),
            name: "",
            include: {
                weight: true,
                coins: true,
            },
            coins: {
                copper: 0,
                silver: 0,
                electrum: 0,
                gold: 0,
            },
            info: "",
            weight: 0,
            items: []
        },
        override ?? {}
    )
    const baseItem = {
        name: "",
        weight: 0,
        count: 1,
        info: ""
    }

    const sumWeight = (total, item) => {
        if (item.include?.weight === false) {
            return total
        }
        return total + item.weight
    }
</script>

<script>
    import * as ze from "@axel669/zephyr"
    import asuid from "@axel669/asuid"
    import sort from "@axel669/array-sort"

    import NewBag from "./new-bag.svelte"
    import NewItem from "./new-item.svelte"
    import ItemList from "./item-list.svelte"

    const {
        char = $bindable()
    } = $props()

    const { close } = ze.modalContext()

    let nextItem = $state({ ...baseItem })

    const addItem = (add) => {
        if (add !== true) {
            return
        }
        char.bags[bagIndex].items.push(nextItem)
        char.bags[bagIndex].items.sort(
            sort.prop(".name", sort.natural)
        )
        nextItem = { ...baseItem }
    }

    let nextBag = $state(null)
    let bagIndex = $state(0)
    const bagList = $derived(
        char.bags.map(
            (bag, index) => ({ label: bag.name, value: index })
        )
    )
    const resetNext = () => nextBag = newBag()
    const addBag = (add) => {
        if (add !== true) {
            return
        }
        const currentBag = char.bags[bagIndex]
        char.bags.push(nextBag)
        char.bags.sort(
            sort.compose(
                sort.prop(".pos", sort.number),
                sort.prop(".name", sort.natural),
                sort.prop(".time", sort.number)
            )
        )
        bagIndex = char.bags.indexOf(currentBag)
    }

    // const charWeight = char.bags.reduce(
    // )
</script>

<ze.Screen>
    <ze.Paper card r="0px">
        {#snippet header()}
            <ze.Grid cols="repeat(6, 1fr)" p.y="0px">
                <ze.Titlebar col="span 6">
                    {#snippet title()}
                        <ze.Text title>{char.name} - Inventory</ze.Text>
                    {/snippet}
                </ze.Titlebar>

                <ze.EntryButton onentry={addBag} onopen={resetNext}
                outline color="@secondary">
                    <ze.Icon name="info-hexagon" t.sz="18px" />
                    {#snippet modal()}
                        <NewBag bind:nextBag />
                    {/snippet}
                </ze.EntryButton>

                <ze.Select
                    bind:value={bagIndex}
                    options={bagList}
                    col="span 4"
                    color="@primary"
                />

                <ze.EntryButton onentry={addBag} onopen={resetNext}
                outline color="@secondary" t.sz="18px">
                    <ze.Icon name="plus" />
                    <ze.Icon name="moneybag" />
                    {#snippet modal()}
                        <NewBag bind:nextBag />
                    {/snippet}
                </ze.EntryButton>
            </ze.Grid>
        {/snippet}

        <ItemList bind:bag={char.bags[bagIndex]} />

        {#snippet footer()}
            <ze.Grid cols="1fr 1fr">
                <ze.Button onclick={() => close(null)} color="@primary" outline>
                    Close
                </ze.Button>

                <ze.EntryButton onentry={addItem} outline color="@secondary">
                    <ze.Icon name="plus" /> Add Item
                    {#snippet modal()}
                        <NewItem bind:nextItem bag={char.bags[bagIndex]} />
                    {/snippet}
                </ze.EntryButton>
            </ze.Grid>
        {/snippet}
    </ze.Paper>
</ze.Screen>
